module.exports = __webpack_public_path__ + "static/img/7.a78d7b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/sp/7.png
// module id = xvwV
// module chunks = 0